<template>
  <!-- 悬浮分享按钮 -->
  <transition name="share-fade">
    <div 
      v-if="visible" 
      class="share-float-btn"
      @click="openPanel"
      :class="{ 'is-animating': isAnimating }"
      @mouseenter="isAnimating = true"
      @mouseleave="isAnimating = false"
    >
      <div class="share-icon">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24917 15.0227 5.37061L8.08261 9.26934C7.54305 8.49986 6.6572 8 5.66667 8C4.19391 8 3 9.19391 3 10.6667C3 12.1394 4.19391 13.3333 5.66667 13.3333C6.6572 13.3333 7.54305 12.8335 8.08261 12.064L15.0227 15.9627C15.0077 16.0842 15 16.2079 15 16.3333C15 17.8061 16.1939 19 17.6667 19C19.1394 19 20.3333 17.8061 20.3333 16.3333C20.3333 14.8606 19.1394 13.6667 17.6667 13.6667C16.6761 13.6667 15.7903 14.1665 15.2507 14.936L8.31061 11.0373C8.32564 10.9158 8.33333 10.7921 8.33333 10.6667C8.33333 10.5412 8.32564 10.4175 8.31061 10.2961L15.2507 6.39734C15.7903 7.16683 16.6761 7.66667 17.6667 7.66667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="share-text">分享</span>
    </div>
  </transition>
  
  <!-- 底部分享面板 -->
  <transition name="panel-slide">
    <div v-if="showBottomPanel" class="share-panel-overlay" @click="closePanel">
      <div class="share-panel" @click.stop>
        <!-- 面板头部 -->
        <div class="panel-header">
          <span class="panel-title">分享到</span>
          <div class="close-btn" @click="closePanel">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        
        <!-- 分享数据预览 -->
        <div class="share-preview">
          <div class="preview-label">分享内容预览</div>
          <div class="preview-content">
            <div v-if="getDefaultShareImage()" class="preview-image">
              <img :src="getDefaultShareImage()" alt="分享图片" />
            </div>
            <div class="preview-info">
              <div class="preview-title">{{ articleData.title || '暂无标题' }}</div>
              <div class="preview-desc">{{ articleData.articleAbstract || '暂无描述' }}</div>
              <div class="preview-url">{{ currentUrl }}</div>
            </div>
          </div>
        </div>
        
        <!-- 分享选项列表 -->
        <div class="share-options-grid">
          <!-- 微信好友分享 -->
          <div 
            v-if="isWechatEnv" 
            class="share-option-item"
            @click="handleShareFriend"
          >
            <div class="option-icon wechat-friend">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.69124 2.18774C5.65324 2.18774 3.12524 4.71574 3.12524 7.75374C3.12524 10.0317 4.38524 11.9837 6.25124 13.3057V16.2617C6.25124 16.6037 6.52924 16.8817 6.87124 16.8817C7.21324 16.8817 7.49124 16.6037 7.49124 16.2617V13.4697C8.31524 14.0777 9.33724 14.5257 10.5012 14.7537V20.5617C10.5012 20.9037 10.7792 21.1817 11.1212 21.1817C11.4632 21.1817 11.7412 20.9037 11.7412 20.5617V14.7537C12.9052 14.5257 13.9272 14.0777 14.7512 13.4697V16.2617C14.7512 16.6037 15.0292 16.8817 15.3712 16.8817C15.7132 16.8817 15.9912 16.6037 15.9912 16.2617V13.3057C17.8572 11.9837 19.1172 10.0317 19.1172 7.75374C19.1172 4.71574 16.5892 2.18774 13.5512 2.18774C12.2052 2.18774 10.9652 2.68174 10.0012 3.52974C9.03724 2.68174 7.79724 2.18774 6.45124 2.18774C6.22324 2.18774 6.00124 2.20974 5.78524 2.25374C6.94124 2.10174 8.08924 2.16574 8.69124 2.18774Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">微信好友</span>
          </div>
          
          <!-- 朋友圈分享 -->
          <div 
            v-if="isWechatEnv" 
            class="share-option-item"
            @click="handleShareTimeline"
          >
            <div class="option-icon wechat-timeline">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12c0-5.523-4.477-10-10-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">朋友圈</span>
          </div>
          
          <!-- QQ分享 -->
          <div class="share-option-item" @click="handleShareQQ">
            <div class="option-icon qq">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">QQ</span>
          </div>
          
          <!-- 微博分享 -->
          <div class="share-option-item" @click="handleShareWeibo">
            <div class="option-icon weibo">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.098 20.323c-3.977.391-7.414-1.406-7.672-4.02-.259-2.609 2.759-5.047 6.74-5.441 3.979-.394 7.413 1.404 7.671 4.018.259 2.6-2.759 5.049-6.739 5.443z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">微博</span>
          </div>
          
          <!-- 复制链接 -->
          <div class="share-option-item" @click="handleCopyLink">
            <div class="option-icon copy-link">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">复制链接</span>
          </div>
          
          <!-- 分享链接 -->
          <div class="share-option-item" @click="handleShareLink">
            <div class="option-icon share-link">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-0.23.09-0.46.09-0.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81c-.54-.5-1.25-.81-2.04-.81-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span class="option-text">分享链接</span>
          </div>
        </div>
        
        <!-- 取消按钮 -->
        <div class="cancel-btn" @click="closePanel">
          <span>取消</span>
        </div>
      </div>
    </div>
  </transition>
  
  <!-- 分享提示弹窗 -->
  <transition name="tip-fade">
    <div v-if="showTip" class="share-tip" @click.stop>
      <div class="share-tip-content">
        <div class="share-tip-arrow"></div>
        <p>点击右上角 <span class="share-icon-text">···</span></p>
        <p>选择【分享给朋友】或【分享到朋友圈】</p>
      </div>
    </div>
  </transition>
  
  <!-- 复制成功提示 -->
  <transition name="toast-fade">
    <div v-if="showCopyToast" class="copy-toast">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/>
      </svg>
      <span>链接已复制</span>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch, onUpdated } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { getCurrentInstance } from 'vue'
import { isShareEnabled } from '@/config/shareConfig.js'
import { getShareVisibilityDetails, getProjectId } from '@/config/projectConfig.js'
import { initWxSdk, setShareData, isWechatBrowser } from '@/utils/wechatSdk.js'

const route = useRoute()
const store = useStore()
const { proxy } = getCurrentInstance() || {}

// 响应式状态
const visible = ref(false)
const showTip = ref(false)
const isAnimating = ref(false)
const showBottomPanel = ref(false)
const showCopyToast = ref(false)

// 分享状态管理
const shareState = ref({
  isSdkReady: false,
  isDataLoaded: false,
  lastExtractTime: 0
})

// 文章数据（用于分享）
const articleData = ref({
  title: '',
  articleAbstract: '',
  pictureUrl: ''
})

// 当前页面URL（安全获取）
const currentUrl = computed(() => {
  try {
    return window?.location?.href || ''
  } catch (e) {
    return ''
  }
})

// 获取全局 commenUrl
const commenUrl = computed(() => {
  try {
    // 尝试从多个来源获取 commenUrl
    const sources = [
      proxy?.commenUrl,
      window?.vm?.config?.globalProperties?.commenUrl,
      window?.commenUrl,
      process.env?.VUE_APP_PUBLIC_PATH
    ]
    for (const source of sources) {
      if (source && typeof source === 'string' && source.trim()) {
        return source.trim()
      }
    }
    // 如果都没获取到，尝试从当前URL构建
    const current = currentUrl.value
    if (current) {
      const url = new URL(current)
      return `${url.protocol}//${url.host}/induDoor/sr/`
    }
    return ''
  } catch (e) {
    return ''
  }
})

// 获取 portalInfo 中的 logo
const portalLogo = computed(() => {
  try {
    // 尝试从多个来源获取 logo
    const sources = [
      store?.state?.portalInfo?.logo,
      window?.$store?.state?.portalInfo?.logo,
      window?.vm?.$store?.state?.portalInfo?.logo
    ]
    for (const source of sources) {
      if (source && typeof source === 'string' && source.trim()) {
        return source.trim()
      }
    }
    return ''
  } catch (e) {
    return ''
  }
})

// 增强的图片URL处理函数
const validateAndBuildImageUrl = (pictureUrl) => {
  if (!pictureUrl || typeof pictureUrl !== 'string') {
    return ''
  }
  
  const trimmedUrl = pictureUrl.trim()
  
  // 如果已经是完整URL，直接返回（生产环境强制HTTPS）
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    if (process.env.NODE_ENV === 'production' && trimmedUrl.startsWith('http://')) {
      return trimmedUrl.replace('http://', 'https://')
    }
    return trimmedUrl
  }
  
  // 相对路径，拼接 commenUrl
  const baseUrl = commenUrl.value
  if (!baseUrl) {
    console.warn('[ShareButton] commenUrl 未配置，无法构建完整图片URL')
    // 尝试从当前URL构建
    const current = currentUrl.value
    if (current) {
      try {
        const url = new URL(current)
        const constructedBase = `${url.protocol}//${url.host}/induDoor/sr/`
        const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl.substring(1) : trimmedUrl
        return constructedBase + normalizedUrl
      } catch (e) {
        console.warn('[ShareButton] 构建图片URL失败:', e)
        return trimmedUrl
      }
    }
    return trimmedUrl
  }
  
  // 确保路径格式正确
  const normalizedUrl = trimmedUrl.startsWith('/') ? trimmedUrl.substring(1) : trimmedUrl
  return baseUrl + normalizedUrl
}

// 检查是否在微信环境
const isWechatEnv = computed(() => {
  return isWechatBrowser()
})

// 计算是否显示分享按钮（应用完整的验证规则）
const shouldShow = computed(() => {
  // 步骤1: 获取项目配置详情
  const configResult = getShareVisibilityDetails()
  
  console.info('[ShareButton] 分享配置检查开始 ============')
  console.info('[ShareButton] 当前路由路径:', route.path)
  console.info('[ShareButton] 当前页面URL:', currentUrl.value)
  console.info('[ShareButton] 微信环境检测:', isWechatBrowser())
  console.info('[ShareButton] 项目标识:', configResult.projectId)
  console.info('[ShareButton] 项目配置:', configResult.config)
  console.info('[ShareButton] 分享启用状态:', configResult.shareEnabled)
  console.info('[ShareButton] AppID有效性:', configResult.appidValid)
  console.info('[ShareButton] 基础分享功能:', isShareEnabled())
  
  // 条件验证：
  // a) 未获取到有效的项目标识
  if (!configResult.projectId || configResult.projectId.trim() === '') {
    console.info('[ShareButton] ❌ 条件a不满足: 未获取到有效的项目标识')
    return false
  }
  
  // b) 根据项目标识未查询到对应的项目配置信息
  if (!configResult.config) {
    console.info('[ShareButton] ❌ 条件b不满足: 根据项目标识未查询到对应的项目配置信息')
    return false
  }
  
  // c) 项目配置中的分享展示标识设置为false
  if (configResult.shareEnabled === false) {
    console.info('[ShareButton] ❌ 条件c不满足: 项目配置中的分享展示标识设置为false')
    return false
  }
  
  // d) 项目配置中未正确配置微信appid参数
  if (!configResult.appidValid) {
    console.info('[ShareButton] ❌ 条件d不满足: 项目配置中未正确配置微信appid参数')
    return false
  }
  
  // 基础分享功能启用检查
  if (!isShareEnabled()) {
    console.info('[ShareButton] ❌ 基础分享功能未启用')
    return false
  }
  
  // 页面路径检查
  const fullPath = route.path
  const allowedPaths = ['/h5/newsDetail', '/newsDetail']
  const isAllowedPage = allowedPaths.some(pagePath => {
    return fullPath === pagePath || fullPath.startsWith(pagePath + '?') || fullPath.startsWith(pagePath + '/')
  })
  
  if (!isAllowedPage) {
    console.info('[ShareButton] ❌ 当前页面不允许分享:', fullPath, '允许的路径:', allowedPaths)
    return false
  }
  
  // 所有条件都满足
  console.info('[ShareButton] ✅ 分享功能展示条件全部满足，项目标识:', configResult.projectId)
  console.info('[ShareButton] 分享配置检查结束 ============')
  return true
})

// 从页面提取文章数据（优化版）
const extractArticleData = () => {
  const now = Date.now()
  
  // 5秒内不重复提取（缓存机制）
  if (now - shareState.value.lastExtractTime < 5000) {
    console.info('[ShareButton] 数据提取间隔不足5秒，跳过提取')
    return
  }
  
  shareState.value.lastExtractTime = now
  
  try {
    // 定义数据来源优先级
    const dataSources = [
      // 优先级1: Vue组件数据（最准确）
      () => getVueComponentData(),
      // 优先级2: 页面DOM元素
      () => getDomElementData(),
      // 优先级3: Meta标签（Open Graph）
      () => getMetaTagData(),
      // 优先级4: 默认配置
      () => getDefaultShareData()
    ]
    
    let result = null
    
    // 按优先级尝试获取数据
    for (const source of dataSources) {
      try {
        const data = source()
        if (data && isValidShareData(data)) {
          result = data
          break
        }
      } catch (e) {
        console.warn('[ShareButton] 数据来源获取失败:', e)
      }
    }
    
    // 如果获取到有效数据，更新并验证
    if (result) {
      // 使用增强的图片URL处理
      result.pictureUrl = validateAndBuildImageUrl(result.pictureUrl)
      
      // 只有当数据发生变化时才更新
      if (JSON.stringify(result) !== JSON.stringify(articleData.value)) {
        articleData.value = result
        shareState.value.isDataLoaded = true
        console.info('[ShareButton] 文章数据更新:', result)
      }
    }
    
  } catch (err) {
    console.error('[ShareButton] 提取文章数据异常:', err)
    // 使用默认值
    articleData.value = getDefaultShareData()
    articleData.value.pictureUrl = validateAndBuildImageUrl(articleData.value.pictureUrl)
  }
  
  // 数据验证：确保至少有标题
  if (!articleData.value.title) {
    articleData.value.title = document.title || '分享'
  }
}

// 从Vue组件获取数据
const getVueComponentData = () => {
  const appElement = document.getElementById('app')
  if (!appElement) return null
  
  try {
    const vueInstance = appElement.__vue__ || appElement._vueRoot || null
    if (!vueInstance) return null
    
    const findArticleData = (vm) => {
      if (!vm) return null
      if (vm.articleData) return vm.articleData
      if (vm._data && vm._data.articleData) return vm._data.articleData
      if (vm.setupState && vm.setupState.articleData) return vm.setupState.articleData
      if (vm.$children && Array.isArray(vm.$children)) {
        for (const child of vm.$children) {
          const result = findArticleData(child)
          if (result) return result
        }
      }
      if (vm.component?.setupState?.articleData) return vm.component.setupState.articleData
      return null
    }
    
    return findArticleData(vueInstance)
  } catch (e) {
    return null
  }
}

// 从DOM元素获取数据
const getDomElementData = () => {
  const titleElement = document.querySelector('.news-title span, .title, .article-title, .articleTitle')
  const descElement = document.querySelector('.news-desc span, .abstract, .article-desc, .articleDesc')
  const imgElement = document.querySelector('.article-content img, article img, .news-cont img, .newsDetail img')
  
  return {
    title: titleElement?.textContent?.trim(),
    articleAbstract: descElement?.textContent?.trim(),
    pictureUrl: imgElement?.src || ''
  }
}

// 从Meta标签获取数据
const getMetaTagData = () => {
  return {
    title: document.querySelector('meta[property="og:title"]')?.content || document.querySelector('meta[name="title"]')?.content,
    articleAbstract: document.querySelector('meta[property="og:description"]')?.content || document.querySelector('meta[name="description"]')?.content,
    pictureUrl: document.querySelector('meta[property="og:image"]')?.content || ''
  }
}

// 获取默认分享数据
const getDefaultShareData = () => {
  return {
    title: document.title || '分享',
    articleAbstract: '点击查看更多精彩内容',
    pictureUrl: getDefaultShareImage() || ''
  }
}

// 验证分享数据是否有效
const isValidShareData = (data) => {
  return data && data.title && data.title.trim().length > 0
}

// 关闭面板
const closePanel = () => {
  showBottomPanel.value = false
}

// 打开面板时提取数据
const openPanel = () => {
  showBottomPanel.value = true
  // 延迟一点确保DOM更新
  setTimeout(() => {
    extractArticleData()
  }, 50)
}

// 处理分享到微信好友（带降级处理）
const handleShareFriend = () => {
  closePanel()
  
  if (!isWechatEnv.value) {
    // 非微信环境降级为复制链接
    console.info('[ShareButton] 非微信环境，降级为复制链接')
    handleCopyLink()
    return
  }
  
  // 检查SDK是否初始化成功
  if (!shareState.value.isSdkReady) {
    console.warn('[ShareButton] 微信SDK未初始化，降级为复制链接')
    handleCopyLink()
    return
  }
  
  // 重新提取并设置分享数据（确保数据最新）
  extractArticleData()
  updateShareData({})
  
  showTip.value = true
  
  setTimeout(() => {
    showTip.value = false
  }, 3500)
}

// 处理分享到朋友圈（带降级处理）
const handleShareTimeline = () => {
  closePanel()
  
  if (!isWechatEnv.value) {
    // 非微信环境降级为复制链接
    console.info('[ShareButton] 非微信环境，降级为复制链接')
    handleCopyLink()
    return
  }
  
  // 检查SDK是否初始化成功
  if (!shareState.value.isSdkReady) {
    console.warn('[ShareButton] 微信SDK未初始化，降级为复制链接')
    handleCopyLink()
    return
  }
  
  // 重新提取并设置分享数据（确保数据最新）
  extractArticleData()
  updateShareData({})
  
  showTip.value = true
  
  setTimeout(() => {
    showTip.value = false
  }, 3500)
}

// 处理QQ分享
const handleShareQQ = () => {
  closePanel()
  const url = encodeURIComponent(currentUrl.value)
  const title = encodeURIComponent(articleData.value.title || document.title)
  const desc = encodeURIComponent(articleData.value.articleAbstract || '')
  window.open(`https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&desc=${desc}`, '_blank')
}

// 处理微博分享
const handleShareWeibo = () => {
  closePanel()
  const url = encodeURIComponent(currentUrl.value)
  const title = encodeURIComponent(articleData.value.title || document.title)
  const desc = encodeURIComponent(articleData.value.articleAbstract || '')
  window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}&desc=${desc}`, '_blank')
}

// 处理复制链接（优化版）
const handleCopyLink = async () => {
  closePanel()
  
  try {
    const url = currentUrl.value
    
    // 尝试使用现代Clipboard API
    if (navigator?.clipboard) {
      await navigator.clipboard.writeText(url)
    } else {
      // 降级方案
      fallbackCopyToClipboard(url)
    }
    
    // 显示复制成功提示
    showCopyToast.value = true
    setTimeout(() => {
      showCopyToast.value = false
    }, 2500)
    
    // 震动反馈（如果支持）
    if ('vibrate' in navigator) {
      navigator.vibrate(50)
    }
    
  } catch (err) {
    console.error('[ShareButton] 复制链接失败:', err)
    // 使用更友好的错误提示
    showCopyToast.value = true
    setTimeout(() => {
      showCopyToast.value = false
    }, 2500)
  }
}

// 处理分享链接
const handleShareLink = () => {
  closePanel()
  
  if (navigator?.share) {
    navigator.share({
      title: articleData.value.title || document.title,
      text: articleData.value.articleAbstract || '点击查看更多精彩内容',
      url: currentUrl.value
    }).then(() => {
    }).catch((err) => {
      if (err.name !== 'AbortError') {
        handleCopyLink()
      }
    })
  } else {
    handleCopyLink()
  }
}

// 降级复制方案
const fallbackCopyToClipboard = (text) => {
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  
  try {
    document.execCommand('copy')
  } catch (err) {
    throw err
  } finally {
    document.body.removeChild(textarea)
  }
}

// 更新分享数据
const updateShareData = (data) => {
  // 提取文章数据
  extractArticleData()
  
  if (isWechatBrowser()) {
    const shareTitle = data?.title || articleData.value.title || document.title
    const shareDesc = data?.desc || articleData.value.articleAbstract || '点击查看更多精彩内容'
    const shareLink = data?.link || currentUrl.value
    // getDefaultShareImage() 已经返回完整URL，不需要再用 buildFullImageUrl() 处理
    const shareImgUrl = buildFullImageUrl(data?.imgUrl || articleData.value.pictureUrl) || getDefaultShareImage()
    
    console.info('[ShareButton] 设置分享数据:', {
      title: shareTitle,
      desc: shareDesc,
      link: shareLink,
      imgUrl: shareImgUrl,
      sdkReady: shareState.value.isSdkReady
    })
    
    // 确保 SDK 已初始化后再设置分享数据
    if (shareState.value.isSdkReady) {
      setShareData({
        title: shareTitle,
        desc: shareDesc,
        link: shareLink,
        imgUrl: shareImgUrl
      })
    } else {
      console.warn('[ShareButton] SDK 未就绪，延迟设置分享数据')
      // 延迟重试
      setTimeout(() => {
        if (shareState.value.isSdkReady) {
          setShareData({
            title: shareTitle,
            desc: shareDesc,
            link: shareLink,
            imgUrl: shareImgUrl
          })
        }
      }, 500)
    }
  }
}

// 根据项目标识获取本地项目logo
const getProjectLogo = () => {
  try {
    // 获取当前项目标识
    const projectId = getProjectId()
    if (!projectId) return ''
    
    // 根据项目标识动态拼接路径
    // 文件位置: public/image/logo/{projectId}/logo.jpg
    // 开发环境访问: /image/logo/{projectId}/logo.jpg
    // 生产环境访问: /induDoor/image/logo/{projectId}/logo.jpg
    const logoPath = `/image/logo/${projectId}/logo.jpg`
    
    const origin = currentUrl.value ? new URL(currentUrl.value).origin : ''
    
    // 根据环境构建完整URL
    let fullUrl = ''
    if (process.env.NODE_ENV === 'production') {
      // 生产环境添加 publicPath
      fullUrl = origin + '/induDoor' + logoPath
      // 生产环境强制HTTPS
      if (fullUrl.startsWith('http://')) {
        fullUrl = fullUrl.replace('http://', 'https://')
      }
    } else {
      // 开发环境直接使用根路径
      fullUrl = origin + logoPath
    }
    
    return fullUrl
  } catch (e) {
    console.warn('[ShareButton] 获取项目logo失败:', e)
    return ''
  }
}

// 默认备用分享图片（尺寸：1000x1000，满足微信要求）
const DEFAULT_SHARE_IMAGE = 'https://www.kyzqniuye.com/sr/1537282/163/14/fd57c5f9b6524c609062600cec6a7112.jpg'

// 异步检查图片尺寸（通过创建 Image 对象，支持远程图片）
const checkImageSizeAsync = (imgUrl, timeout = 3000) => {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      console.warn(`[ShareButton] 图片尺寸检查超时: ${imgUrl}`)
      // 超时也视为无效，跳过该图片
      resolve({ width: 0, height: 0, isValid: false, reason: 'timeout' })
    }, timeout)

    try {
      const img = new Image()
      // 处理跨域图片
      img.crossOrigin = 'anonymous'
      
      img.onload = () => {
        clearTimeout(timer)
        const isValid = img.naturalWidth >= 300 && img.naturalHeight >= 300
        console.log(`[ShareButton] 图片尺寸检查完成: ${imgUrl}, 尺寸: ${img.naturalWidth}x${img.naturalHeight}, 有效: ${isValid}`)
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight,
          isValid,
          reason: isValid ? 'valid' : 'size_too_small'
        })
      }

      img.onerror = () => {
        clearTimeout(timer)
        console.warn(`[ShareButton] 图片加载失败（可能是404）: ${imgUrl}`)
        // 图片加载失败（包括404），直接跳过，视为无效
        resolve({ width: 0, height: 0, isValid: false, reason: 'load_failed' })
      }

      img.src = imgUrl
    } catch (e) {
      clearTimeout(timer)
      console.warn('[ShareButton] 检查图片尺寸失败:', e)
      resolve({ width: 0, height: 0, isValid: false, reason: 'exception' })
    }
  })
}

// 同步检查图片尺寸（用于已加载的图片）
const checkImageSizeSync = (imgUrl) => {
  try {
    const img = new Image()
    img.src = imgUrl
    // 对于已经加载到页面的图片，naturalWidth/naturalHeight 会有值
    if (img.complete && img.naturalWidth) {
      return {
        width: img.naturalWidth,
        height: img.naturalHeight,
        isValid: img.naturalWidth >= 300 && img.naturalHeight >= 300
      }
    }
    // 对于未加载的图片，无法同步获取尺寸，返回默认有效
    return { width: 0, height: 0, isValid: true }
  } catch (e) {
    console.warn('[ShareButton] 检查图片尺寸失败:', e)
    return { width: 0, height: 0, isValid: true }
  }
}

// 获取默认分享图片（微信分享图片要求：尺寸>=300x300，格式jpg/png，大小<=1MB）
const getDefaultShareImage = () => {
  let candidateImages = []
  
  // 1. 优先从文章数据的 pictureUrl 获取分享图片
  if (articleData.value.pictureUrl) {
    const imgUrl = buildFullImageUrl(articleData.value.pictureUrl)
    const sizeInfo = checkImageSizeSync(imgUrl)
    console.log(`[ShareButton] 文章图片: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }
  
  // 2. 从 portalInfo.logo 提取
  if (portalLogo.value) {
    const imgUrl = buildFullImageUrl(portalLogo.value)
    const sizeInfo = checkImageSizeSync(imgUrl)
    console.log(`[ShareButton] PortalLogo: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }

  // 3. 从页面 meta 标签（og:image）获取（不拼接 /sr/）
  const ogImage = document.querySelector('meta[property="og:image"]')
  if (ogImage && ogImage.content) {
    // og:image 已经是完整路径或正确的相对路径，不需要拼接 /sr/
    let imgUrl = ogImage.content
    // 如果是相对路径，拼接当前页面的 origin
    if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://') && !imgUrl.startsWith('//')) {
      const origin = currentUrl.value ? new URL(currentUrl.value).origin : ''
      imgUrl = origin + (imgUrl.startsWith('/') ? '' : '/') + imgUrl
    }
    // 生产环境强制转换为 HTTPS
    if (process.env.NODE_ENV === 'production' && imgUrl.startsWith('http://')) {
      imgUrl = imgUrl.replace('http://', 'https://')
    }
    const sizeInfo = checkImageSizeSync(imgUrl)
    console.log(`[ShareButton] OG图片: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }

  // 4. 从页面中提取 logo（带有 logo 类名或属性的图片）
  const logoImg = document.querySelector('img[class*="logo"], img[alt*="logo"], img[src*="logo"]')
  if (logoImg && logoImg.src) {
    const sizeInfo = checkImageSizeSync(logoImg.src)
    console.log(`[ShareButton] 页面Logo: ${logoImg.src}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return logoImg.src
    }
    candidateImages.push(logoImg.src)
  }

  // 5. 从文章内容中的图片获取
  const articleImages = document.querySelectorAll('article img, .content img, .article-content img, img[alt]')
  for (const img of articleImages) {
    if (img.src && isImageValidForShare(img)) {
      const sizeInfo = checkImageSizeSync(img.src)
      console.log(`[ShareButton] 文章内容图片: ${img.src}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
      if (sizeInfo.isValid) {
        return buildFullImageUrl(img.src)
      }
      candidateImages.push(img.src)
    }
  }
  
  // 6. 从页面中任意有效图片获取
  const allImages = document.querySelectorAll('img')
  for (const img of allImages) {
    if (img.src && isImageValidForShare(img)) {
      const sizeInfo = checkImageSizeSync(img.src)
      if (sizeInfo.isValid) {
        return buildFullImageUrl(img.src)
      }
    }
  }
  
  // 7. 如果以上图片都不满足要求，使用默认备用图片
  console.warn(`[ShareButton] 所有候选图片(${candidateImages.length}个)都不满足尺寸要求，使用默认备用图片`)
  return DEFAULT_SHARE_IMAGE
}

// 异步获取分享图片（带尺寸验证）
const getDefaultShareImageAsync = async () => {
  const candidateImages = []
  
  // 1. 优先从文章数据的 pictureUrl 获取分享图片
  if (articleData.value.pictureUrl) {
    const imgUrl = buildFullImageUrl(articleData.value.pictureUrl)
    const sizeInfo = await checkImageSizeAsync(imgUrl)
    console.log(`[ShareButton] 异步检查文章图片: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }
  
  // 2. 从 portalInfo.logo 提取
  if (portalLogo.value) {
    const imgUrl = buildFullImageUrl(portalLogo.value)
    const sizeInfo = await checkImageSizeAsync(imgUrl)
    console.log(`[ShareButton] 异步检查PortalLogo: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }

  // 3. 从页面 meta 标签（og:image）获取（不拼接 /sr/）
  const ogImage = document.querySelector('meta[property="og:image"]')
  if (ogImage && ogImage.content) {
    // og:image 已经是完整路径或正确的相对路径，不需要拼接 /sr/
    let imgUrl = ogImage.content
    // 如果是相对路径，拼接当前页面的 origin
    if (!imgUrl.startsWith('http://') && !imgUrl.startsWith('https://') && !imgUrl.startsWith('//')) {
      const origin = currentUrl.value ? new URL(currentUrl.value).origin : ''
      imgUrl = origin + (imgUrl.startsWith('/') ? '' : '/') + imgUrl
    }
    // 生产环境强制转换为 HTTPS
    if (process.env.NODE_ENV === 'production' && imgUrl.startsWith('http://')) {
      imgUrl = imgUrl.replace('http://', 'https://')
    }
    const sizeInfo = await checkImageSizeAsync(imgUrl)
    console.log(`[ShareButton] 异步检查OG图片: ${imgUrl}, 尺寸: ${sizeInfo.width}x${sizeInfo.height}, 有效: ${sizeInfo.isValid}`)
    if (sizeInfo.isValid) {
      return imgUrl
    }
    candidateImages.push(imgUrl)
  }
  
  // 4. 如果以上图片都不满足要求，使用默认备用图片
  console.warn(`[ShareButton] 所有候选图片(${candidateImages.length}个)都不满足尺寸要求，使用默认备用图片`)
  return DEFAULT_SHARE_IMAGE
}

// 从页面中提取图片服务器地址
const extractImageServerUrl = () => {
  try {
    // 查找页面中已有的完整图片URL
    const images = document.querySelectorAll('img')
    for (const img of images) {
      if (img.src && img.src.startsWith('http')) {
        // 尝试提取图片服务器地址（包含 /sr/ 路径）
        const match = img.src.match(/(http[s]?:\/\/[^/]+\/sr\/)/)
        if (match) {
          return match[1]
        }
      }
    }
    return ''
  } catch (e) {
    return ''
  }
}

// 构建完整的图片 URL（生产环境强制使用 HTTPS）
const buildFullImageUrl = (imgPath) => {
  if (!imgPath) return ''
  
  // 如果已经是完整的 URL（包含协议），直接返回
  if (imgPath.startsWith('http://') || imgPath.startsWith('https://') || imgPath.startsWith('//')) {
    // 生产环境强制转换为 HTTPS
    if (process.env.NODE_ENV === 'production' && imgPath.startsWith('http://')) {
      return imgPath.replace('http://', 'https://')
    }
    return imgPath
  }
  
  // 如果以 / 开头，说明是站点根路径，需要添加 /sr/ 前缀并拼接 origin
  if (imgPath.startsWith('/')) {
    // 移除可能存在的时间戳参数
    const pathWithoutTimestamp = imgPath.replace(/[?&]t=\d+/g, '')
    
    // 如果路径不以 /sr/ 开头，添加 /sr/ 前缀
    let imgPathWithSr = pathWithoutTimestamp
    if (!imgPathWithSr.startsWith('/sr/')) {
      imgPathWithSr = '/sr' + imgPathWithSr
    }
    
    const origin = currentUrl.value ? new URL(currentUrl.value).origin : ''
    let fullPath = origin + imgPathWithSr
    
    // 生产环境强制使用 HTTPS
    if (process.env.NODE_ENV === 'production' && fullPath.startsWith('http://')) {
      fullPath = fullPath.replace('http://', 'https://')
    }
    
    return fullPath
  }
  
  // 否则是相对路径，需要拼接基础 URL
  let baseUrl = commenUrl.value
  
  // 如果 commenUrl 为空，尝试从页面图片中提取
  if (!baseUrl) {
    baseUrl = extractImageServerUrl()
  }
  
  // 如果还是为空，使用当前页面的 origin
  if (!baseUrl) {
    baseUrl = currentUrl.value ? new URL(currentUrl.value).origin + '/sr/' : ''
  }
  
  // 生产环境强制转换 baseUrl 为 HTTPS
  if (process.env.NODE_ENV === 'production' && baseUrl && baseUrl.startsWith('http://')) {
    baseUrl = baseUrl.replace('http://', 'https://')
  }
  
  // 确保路径拼接正确，避免重复的斜杠
  const normalizedPath = imgPath.startsWith('/') ? imgPath : '/' + imgPath
  const normalizedBase = baseUrl.endsWith('/') ? baseUrl : baseUrl + '/'
  return normalizedBase + imgPath.replace(/[?&]t=\d+/g, '')
}

// 检查图片是否适合用于分享
const isImageValidForShare = (img) => {
  // 过滤掉小图标和无效图片
  const invalidPatterns = [
    'favicon',
    '.ico',
    'avatar',
    'icon',
    'logo-small',
    'loading',
    'spinner'
  ]
  
  const srcLower = img.src.toLowerCase()
  for (const pattern of invalidPatterns) {
    if (srcLower.includes(pattern)) {
      return false
    }
  }
  
  // 检查图片尺寸（如果已知）
  if (img.naturalWidth && img.naturalHeight) {
    return img.naturalWidth >= 300 && img.naturalHeight >= 300
  }
  
  // 默认认为有效（除非是明显的小图标）
  return true
}

// 初始化
onMounted(async () => {
  visible.value = shouldShow.value
  
  console.log('[ShareButton] ==================== 分享组件初始化 ====================')
  console.log('[ShareButton] 当前环境:', isWechatBrowser() ? '✅ 微信浏览器' : '❌ 非微信浏览器')
  console.log('[ShareButton] 当前页面URL:', window?.location?.href)
  console.log('[ShareButton] 当前路由:', route.path)
  console.log('[ShareButton] 分享按钮显示状态:', visible.value)
  console.log('[ShareButton] window.project:', window?.project)
  console.log('[ShareButton] window.location.origin:', window?.location?.origin)
  console.log('[ShareButton] ===========================================================')
  
  if (visible.value && isWechatEnv.value) {
    // 先提取一次文章数据（即使还未完全加载）
    extractArticleData()
    console.log('[ShareButton] 初始文章数据:', articleData.value)
    
    // 初始化微信 SDK
    try {
      console.log('[ShareButton] 开始初始化微信SDK...')
      const initialized = await initWxSdk()
      shareState.value.isSdkReady = initialized
      
      console.log('[ShareButton] 微信SDK初始化结果:', initialized)
      
      if (initialized) {
        console.info('[ShareButton] 微信 SDK 初始化成功')
        
        // 设置初始分享数据（使用同步方式快速设置）
        console.log('[ShareButton] 开始设置初始分享数据...')
        updateShareData({})
        
        // 异步验证图片并更新分享数据（确保图片尺寸达标）
        setTimeout(async () => {
          try {
            // 提取最新文章数据
            extractArticleData()
            
            // 异步验证分享图片
            const validImage = await getDefaultShareImageAsync()
            console.log(`[ShareButton] 异步验证完成，使用图片: ${validImage}`)
            
            // 使用验证后的图片更新分享数据
            updateShareData({ imgUrl: validImage })
          } catch (e) {
            console.error('[ShareButton] 异步图片验证失败:', e)
          }
        }, 1500)
        
        // 额外的延迟检查（确保数据已完全加载）
        setTimeout(async () => {
          try {
            extractArticleData()
            const validImage = await getDefaultShareImageAsync()
            updateShareData({ imgUrl: validImage })
          } catch (e) {
            console.error('[ShareButton] 延迟检查更新失败:', e)
          }
        }, 4000)
      } else {
        console.warn('[ShareButton] 微信 SDK 初始化失败')
      }
    } catch (sdkError) {
      console.error('[ShareButton] 微信 SDK 初始化异常:', sdkError)
    }
  }
})

// 监听文章数据变化，自动更新分享数据
watch(articleData, (newData) => {
  if (visible.value && isWechatEnv.value && shareState.value.isSdkReady) {
    console.info('[ShareButton] 文章数据变化，更新分享数据')
    setTimeout(() => {
      updateShareData({})
    }, 300)
  }
}, { deep: true })

onUnmounted(() => {})

// 监听路由变化
watch(() => route.path, async () => {
  visible.value = shouldShow.value
  
  if (visible.value && isWechatEnv.value) {
    // 路由变化时重新初始化
    await new Promise(resolve => setTimeout(resolve, 500))
    
    try {
      const initialized = await initWxSdk()
      shareState.value.isSdkReady = initialized
    } catch (sdkError) {
      console.error('[ShareButton] 路由变化时SDK初始化异常:', sdkError)
    }
    
    extractArticleData()
    
    setTimeout(() => {
      updateShareData({})
    }, 300)
  }
})

// 更新时重新提取数据
onUpdated(() => {
  if (visible.value) {
    extractArticleData()
  }
})

// 暴露方法供外部调用
defineExpose({
  updateShareData,
  show: () => {
    visible.value = shouldShow.value
  },
  hide: () => {
    visible.value = false
  }
})
</script>

<style lang="less" scoped>
// 悬浮分享按钮
.share-float-btn {
  position: fixed;
  right: 20px;
  bottom: 120px;
  z-index: 9998;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #07c160 0%, #05a350 100%);
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(7, 193, 96, 0.5);
  }
  
  &.is-animating {
    animation: pulse 2s infinite;
  }
  
  .share-icon {
    width: 24px;
    height: 24px;
    color: #fff;
    
    svg {
      width: 100%;
      height: 100%;
    }
  }
  
  .share-text {
    font-size: 11px;
    color: #fff;
    margin-top: 2px;
    font-weight: 500;
  }
}

// 底部分享面板遮罩
.share-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

// 底部分享面板
.share-panel {
  width: 100%;
  max-width: 600px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  padding: 20px 0 40px;
  transform-origin: bottom center;
  will-change: transform, opacity;
  backface-visibility: hidden;
  perspective: 1000px;
  
  // 面板头部
  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 20px;
    border-bottom: 1px solid #f0f0f0;
    
    .panel-title {
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #f5f5f5;
      cursor: pointer;
      color: #999;
      transition: all 0.2s ease;
      
      &:hover {
        background: #e8e8e8;
        color: #666;
      }
      
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }
  
  // 分享选项网格
  .share-options-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 20px 10px;
    max-height: 300px;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  // 分享选项项
  .share-option-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    min-width: 70px;
    padding: 15px 10px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 12px;
    
    &:active {
      transform: scale(0.95);
    }
    
    &:hover {
      background: rgba(7, 193, 96, 0.05);
    }
    
    .option-icon {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      transition: all 0.2s ease;
      
      svg {
        width: 28px;
        height: 28px;
      }
      
      &.wechat-friend {
        background: linear-gradient(135deg, #07c160 0%, #05a350 100%);
        color: #fff;
      }
      
      &.wechat-timeline {
        background: linear-gradient(135deg, #8dc63f 0%, #6ba31c 100%);
        color: #fff;
      }
      
      &.qq {
        background: linear-gradient(135deg, #12b7f5 0%, #0e9de8 100%);
        color: #fff;
      }
      
      &.weibo {
        background: linear-gradient(135deg, #e6162d 0%, #c41020 100%);
        color: #fff;
      }
      
      &.copy-link {
        background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
        color: #fff;
      }
      
      &.share-link {
        background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
        color: #fff;
      }
    }
    
    .option-text {
      font-size: 13px;
      color: #333;
      font-weight: 500;
    }
  }
  
  // 分享数据预览
  .share-preview {
    padding: 15px 20px;
    background: #f8f9fa;
    margin: 10px 20px;
    border-radius: 12px;
    
    .preview-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 10px;
      font-weight: 500;
    }
    
    .preview-content {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      
      .preview-image {
        width: 80px;
        height: 80px;
        border-radius: 8px;
        overflow: hidden;
        flex-shrink: 0;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .preview-info {
        flex: 1;
        min-width: 0;
        
        .preview-title {
          font-size: 14px;
          font-weight: 600;
          color: #333;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 6px;
        }
        
        .preview-desc {
          font-size: 12px;
          color: #999;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 6px;
        }
        
        .preview-url {
          font-size: 10px;
          color: #ccc;
          word-break: break-all;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
  }
  
  // 取消按钮
  .cancel-btn {
    margin: 0 20px;
    padding: 14px;
    background: #f5f5f5;
    border-radius: 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      background: #e8e8e8;
    }
    
    &:active {
      transform: scale(0.98);
    }
    
    span {
      font-size: 16px;
      color: #666;
      font-weight: 500;
    }
  }
}

// 分享提示
.share-tip {
  position: fixed;
  right: 80px;
  bottom: 140px;
  white-space: nowrap;
  z-index: 10001;
  
  .share-tip-content {
    position: relative;
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1.6;
    
    .share-tip-arrow {
      position: absolute;
      right: -6px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid rgba(0, 0, 0, 0.85);
    }
    
    .share-icon-text {
      color: #ffd700;
      font-weight: bold;
    }
    
    p {
      margin: 0;
      
      &:first-child {
        margin-bottom: 4px;
      }
    }
  }
}

// 复制成功提示
.copy-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  z-index: 10002;
  
  svg {
    width: 20px;
    height: 20px;
    color: #07c160;
  }
}

// 脉冲动画
@keyframes pulse {
  0% {
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(7, 193, 96, 0.7);
  }
  100% {
    box-shadow: 0 4px 12px rgba(7, 193, 96, 0.4);
  }
}

// 悬浮按钮淡入淡出动画
.share-fade-enter-active,
.share-fade-leave-active {
  transition: all 0.3s ease;
}

.share-fade-enter-from,
.share-fade-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.9);
}

// 面板滑动动画
.panel-slide-enter-active {
  transition: all 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.panel-slide-leave-active {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.panel-slide-enter-from,
.panel-slide-leave-to {
  opacity: 0;
  
  .share-panel {
    transform: translateY(100%);
  }
}

// 提示动画
.tip-fade-enter-active,
.tip-fade-leave-active {
  transition: all 0.2s ease;
}

.tip-fade-enter-from,
.tip-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// Toast动画
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.9);
}

// 分享成功提示
.share-success-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 40px;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 16px;
  color: #fff;
  font-size: 16px;
  z-index: 10002;
  min-width: 180px;
  text-align: center;
  
  .success-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, #07c160 0%, #05a350 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    
    svg {
      width: 32px;
      height: 32px;
      color: #fff;
    }
  }
}

// 平板端适配
@media (max-width: 768px) {
  .share-float-btn {
    right: 12px;
    bottom: 100px;
    width: 48px;
    height: 48px;
    
    .share-icon {
      width: 20px;
      height: 20px;
    }
    
    .share-text {
      font-size: 10px;
    }
  }
  
  .share-panel {
    padding: 16px 0 30px;
    
    .panel-header {
      padding: 0 16px 16px;
      
      .panel-title {
        font-size: 17px;
      }
    }
    
    .share-options-grid {
      padding: 16px 8px;
    }
    
    .share-option-item {
      padding: 12px 8px;
      
      .option-icon {
        width: 50px;
        height: 50px;
        
        svg {
          width: 24px;
          height: 24px;
        }
      }
      
      .option-text {
        font-size: 12px;
      }
    }
    
    .cancel-btn {
      margin: 0 16px;
      padding: 12px;
      
      span {
        font-size: 15px;
      }
    }
  }
  
  .share-tip {
    right: 60px;
    bottom: 120px;
    
    .share-tip-content {
      padding: 10px 12px;
      font-size: 12px;
    }
  }
}

// 手机端适配
@media (max-width: 480px) {
  .share-float-btn {
    right: 8px;
    bottom: 80px;
    width: 44px;
    height: 44px;
  }
  
  .share-panel {
    padding: 14px 0 25px;
    border-radius: 16px 16px 0 0;
    
    .share-options-grid {
      padding: 14px 5px;
    }
    
    .share-option-item {
      width: 33.33%;
      min-width: 65px;
      padding: 10px 5px;
      
      .option-icon {
        width: 45px;
        height: 45px;
        
        svg {
          width: 22px;
          height: 22px;
        }
      }
      
      .option-text {
        font-size: 11px;
      }
    }
    
    .cancel-btn {
      padding: 11px;
      
      span {
        font-size: 14px;
      }
    }
  }
}

// 小屏适配
@media (max-width: 320px) {
  .share-option-item {
    width: 33.33%;
    
    .option-icon {
      width: 40px;
      height: 40px;
      
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>